import moment, { Moment } from "moment";
import { HTMLAttributes, InputHTMLAttributes, useState } from "react";
import Button from "react-bootstrap/Button";
import Datetime from "react-datetime";

type MomentTimerange = {
  start: Moment;
  end: Moment;
};

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  "data-testid": string;
};

type Props = {
  start?: Moment | string;
  end?: Moment | string;
  type?: "time" | "date";
  onApply?: (timeRange: MomentTimerange) => void;
  startInputProps?: InputHTMLAttributes<HTMLInputElement>;
  endInputProps?: InputHTMLAttributes<HTMLInputElement>;
  btnGroupProps?: HTMLAttributes<HTMLDivElement>;
  className?: string;
};

const getInitialDate = (date: Moment | string | undefined): Moment => {
  if (date) {
    return moment.isMoment(date) ? date : moment(date);
  }
  return moment().utc();
};

const CustomTimerange = ({
  start: initialStart,
  end: initialEnd,
  type = "time",
  onApply,
  startInputProps = {},
  endInputProps = {},
  btnGroupProps = { className: "pull-right" },
  className
}: Props) => {
  const [start, setStart] = useState(() => getInitialDate(initialStart));
  const [end, setEnd] = useState(() => getInitialDate(initialEnd));

  const timeFormat = type === "date" ? false : "HH:mm UTC";

  const handleStartChange = (newStart: Moment) => {
    setStart(newStart);
  };

  const handleEndChange = (newEnd: Moment) => {
    setEnd(newEnd);
  };

  const handleApply = () => {
    onApply?.({ start, end });
  };

  return (
    <div className={className}>
      <div className="rdt__label">From:</div>
      <Datetime
        closeOnSelect
        inputProps={
          {
            ...startInputProps,
            "data-testid": "custom_timerange_start"
          } as InputProps
        }
        dateFormat="YYYY-MM-DD"
        timeFormat={timeFormat}
        initialValue={start}
        onChange={handleStartChange}
      />

      <div className="rdt__label">To:</div>
      <Datetime
        closeOnSelect
        inputProps={
          {
            ...endInputProps,
            "data-testid": "custom_timerange_end"
          } as InputProps
        }
        dateFormat="YYYY-MM-DD"
        timeFormat={timeFormat}
        initialValue={end}
        onChange={handleEndChange}
      />

      <div {...btnGroupProps}>
        <Button
          variant="prompt-primary"
          className="btn--short"
          onClick={handleApply}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default CustomTimerange;
export { MomentTimerange };
